
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
 
        listOnayDurums() {
      return $axios.get('OnayDurum');
    },
              listOnayDurumsed() {
      return $axios.get('OnayDurum/listOnayDurumsed');
    },
                  listAllOnayDurumsed() {
      return $axios.get('OnayDurum/listAllOnayDurumsed');
    },

 
  };